import src from "IMAGE";
export default { src, width: 561, height: 65, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AEBqnOw5cK38KWy0/BxWkfwgKC/8ISYr/CEmK/wfJi7v/wwOerq4w3wAAAAASUVORK5CYII="};
